export default __webpack_public_path__ + "static/media/chat_bot_image3.98b001b9.jpg";